import { useEffect, useState } from "react";
import { getAllStores } from "../../Api/ApiCalls";
import LoadingSpinner from "../../common/Loading";

export const StoresList = () => {
  const [loading, setLoading] = useState(true);
  const [stores, setStores] = useState([]);

  const getstores = async () => {
    setLoading(true);
    try {
      const result = await getAllStores();
      if (result.status) {
        setStores(result.data);
      }
      setLoading(false);
    } catch (err) {
      console.log("Error while fetching all stores", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    getstores();
  }, []);

  return (
    <>
      <div className="grid grid-rows-1">
        <div className="flex overnpmflow-hidden">
          <div className="content relative flex-1 pb-10">
            <h2 className="text-4xl text-[#96BF61] font-bold mb-6">Location</h2>
            {loading && <LoadingSpinner />}
            {!loading && (
              <>
                <div className="grid grid-cols-12 mt-3">
                  <div className="col-span-12 lg:col-span-12">
                    <div className="rounded-[21px] rounded-bl-none rounded-br-none">
                      <div className=" overflow-y-scroll rounded-[21px] rounded-bl-none rounded-br-none">
                        <table className="min-w-full border manage-active-expired-product">
                          <thead className="border bg-white">
                            <tr>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Corporation Code
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Organization Code
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Location Code
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Location Name
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Zip Code
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Status
                              </th>
                              <th className="corp-head font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-3 py-6">
                                Primary Contact
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {stores.length !== 0 &&
                              stores.map((store, index) => {
                                return (
                                  <tr
                                    key={index}
                                    className="bg-white border transition duration-300 ease-in-out hover:bg-gray-100"
                                  >
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3 h-14">
                                      {store?.corporation_code}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3 h-14">
                                      {store?.organization_code}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3 h-14">
                                      {store?.store_code}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {store?.store_name}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {store?.zip_code}
                                    </td>
                                    <td
                                      className={`text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3 ${
                                        store?.store_status === "active"
                                          ? "text-green-600"
                                          : "text-red-600"
                                      }`}
                                    >
                                      {store?.store_status &&
                                        store?.store_status
                                          .charAt(0)
                                          .toUpperCase() +
                                          store?.store_status.slice(1)}
                                    </td>
                                    <td className="text-gray-900 border border-r-0 border-l-0 font-light px-3 py-3">
                                      {store?.primary_contact
                                        ? store?.primary_contact?.user_name
                                        : "-"}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/*  */}
            {!loading && stores.length === 0 && (
              <h2 className="text-2xl font-medium mr-auto text-gray-500 text-center mt-[10%]">
                No Data Found!
              </h2>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
